import { Component, OnInit } from '@angular/core';
import {Observable} from "rxjs";
import {NewSavingsAccountService, SavingsAccount} from "@brightside-web/desktop/feature/savings-account";
import {TransactionPagination} from "@brightside-web/desktop/feature/financial-accounts-core";
import {NewSpendingAccountService, SpendingAccount} from "@brightside-web/desktop/feature/spending-account";

@Component({
    selector: 'brightside-web-spending-account-transaction-history',
    templateUrl: './spending-account-transaction-history.component.html',
    styleUrls: ['./spending-account-transaction-history.component.scss'],
    standalone: false
})
export class SpendingAccountTransactionHistoryComponent implements OnInit {


  currentAccountInfo: Observable<SpendingAccount | undefined>  = this.spendingSvc.currentAccountInfo;
  transactionsHistory: Observable<TransactionPagination|undefined> = this.spendingSvc.transactionHistory;
  hasMoreTransactions: Observable<boolean> = this.spendingSvc.hasMoreTransactions;

  constructor(private spendingSvc: NewSpendingAccountService) {}

  ngOnInit(): void {
    this.spendingSvc.getSpendingAccounts();
    this.spendingSvc.getNextSpendingTransactionsPage();
  }

  loadMore() {
    this.spendingSvc.getNextSpendingTransactionsPage();
  }
}
